import { ReactElement } from 'react';

import { useGlobal } from 'src/contexts/GlobalContext';

import { Header, HeaderDivider } from './PageHeader.styled';

interface PageHeaderProps {
  children: ReactElement[] | ReactElement;
  margin?: string;
}

export const PageHeader = (props: PageHeaderProps) => {
  const { children, margin } = props;
  const { isDesktop } = useGlobal();
  return (
    <>
      <Header $isDesktop={isDesktop}>{children}</Header>
      <HeaderDivider $margin={margin} />
    </>
  );
};
